import { Col, Sidepanel, Spinner2 } from 'components';
import { theme } from 'lib';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ContentHeader } from 'screens/Admin/components';
import { P4PDayGift, Settings, User, Verify } from './components';

const UserPanel = ({ dataId, closeModal, hasBack }) => {
  const [verifyIdVisible, setVerifyIdVisible] = useState(false),
    // Owned here, not in Settings: ContentHeader takes `SettingsComponent` as a new arrow
    // function every render, so React remounts that whole subtree and resets any state inside
    // it. Verify is arranged the same way for the same reason.
    [p4pDayVisible, setP4PDayVisible] = useState(false),
    [data, setData] = useState(null),
    [showRemoveAlert, setShowRemoveAlert] = useState(false),
    storedData = useSelector((state) => state.admin?.users?.find((x) => x._id === dataId));

  function handleVerifyId() {
    setVerifyIdVisible(!verifyIdVisible);
  }

  function handleP4PDayVisible() {
    setP4PDayVisible(!p4pDayVisible);
  }

  return (
    <React.Fragment>
      <Sidepanel wid={600} pad="0" visible={dataId} closeModal={closeModal}>
        <ContentHeader
          text={storedData ? storedData.name || storedData.username : 'Create new user'}
          SettingsComponent={() => (
            <Settings
              user={storedData}
              setVerifyIdVisible={setVerifyIdVisible}
              verifyIdVisible={verifyIdVisible}
              onOpenP4PDay={handleP4PDayVisible}
              setShowRemoveAlert={setShowRemoveAlert}
            />
          )}
          closePanel={hasBack && closeModal}
        />

        {dataId && (typeof dataId === 'string' ? !storedData : false) && (
          <Col
            zIndex={5}
            pos="absolute"
            ht="100%"
            wid="100%"
            bg="rgba(210, 216, 223, 0.7)"
            left="0"
            centerAll
          >
            <Spinner2 col={theme.SECONDARY} />
          </Col>
        )}

        {dataId && (typeof dataId === 'string' ? storedData : true) && (
          <User
            user={storedData}
            closeModal={closeModal}
            setShowRemoveAlert={setShowRemoveAlert}
            showRemoveAlert={showRemoveAlert}
          />
        )}
      </Sidepanel>

      <Verify user={storedData} visible={verifyIdVisible} closeModal={handleVerifyId} />

      <P4PDayGift user={storedData} visible={p4pDayVisible} close={handleP4PDayVisible} />
    </React.Fragment>
  );
};

export default UserPanel;
